import { t } from 'i18next';
import { nbsp } from './misc';

export const numberToPLN = (value: number): string => `${Number.isInteger(value) ? value : value.toFixed(2)}${nbsp}${t('PLN')}`;
